<template>
  <div class="pt-2 h-full flex flex-col">
    <!-- Floating Action Bar for bulk actions -->
    <FloatingActionBar
      :selected="selectedRoles"
      :total-items="totalRoles"
      v-iam-disabled="'organization.roles.delete'"
      :showDeleteSelected="true"
      :show-assign="false"
      :showDeleteAll="false"
      :showUpdateStatus="false"
      :showSelectAll="false"
      @delete-selected="handleShowDialogDelete"
    />
    <!-- <div
      class="justify-end items-center ml-auto"
      :class="[$vuetify.breakpoint.lgAndUp ? 'flex mb-4' : 'flex flex-col']"
    >
      <v-col
        :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
        :class="[$vuetify.breakpoint.lgAndUp ? 'py-0 pr-0' : 'ml-auto mt-2 p-0']"
      >
        <v-text-field
          outlined
          dense
          hide-details
          placeholder="Search Role"
          v-model="filterRole"
          @input="handleInput"
          clearable
        ></v-text-field>
      </v-col>
    </div> -->
    <v-dialog
      v-model="showForm"
      max-width="75%"
      max-height="90vh"
      class="px-2"
      content-class="dialog-content"
      persistent
    >
      <v-card class="d-flex flex-column">
        <ActitiveTabcomponent
          :tabs="mainTabs"
          :defaultTab="'lender'"
          class="flex-grow-1 d-flex flex-column"
        >
          <template #tab-buttons>
            <v-btn icon @click="closeForm">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <template #lender>
            <div class="d-flex flex-column form-content">
              <!-- Tooltip/Help Text -->
              <div class="help-text text-start mx-4 my-2">
                <strong>Role:</strong> Defines what this user can access and do in the system.
                <br />
                <strong>Examples:</strong> ADMIN, HR_MANAGER, EMPLOYEE, TEAM_LEAD
                <br />
                <em>Note: This controls system permissions and features available to the user.</em>
              </div>
              <v-card-title class="flex-shrink-0 bg-white dark-bg-custom shadow-sm">
                <div class="flex flex-col w-full">
                  <v-text-field
                    autofocus
                    v-model="roleName"
                    label="Role Name"
                    hide-details
                    :error-messages="roleNameValidationRule"
                    ref="roleNameField"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-card-title>
              <v-card-text class="mt-2 flex-grow-1 px-0">
                <v-expansion-panels v-model="panel" flat outlined accordion>
                  <v-expansion-panel class="my-3 border border-gray-300">
                    <v-expansion-panel-header class="py-0">
                      <h3 class="font-medium text-lg text-black dark-text-color">Privilege</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="flex justify-end mb-2">
                        <v-btn
                          :color="$vuetify.theme.currentTheme.primary"
                          class="white--text"
                          @click="toggleAllPrivilegePermissions"
                          small
                        >
                          {{ allPrivilegePermissionsText }}
                        </v-btn>
                      </div>
                      <v-row>
                        <v-col cols="6">
                          <v-checkbox
                            :color="$vuetify.theme.currentTheme.primary"
                            @click="checkFormChanges"
                            v-for="(permission, index) in additionalPermissions.slice(
                              0,
                              Math.ceil(additionalPermissions.length / 2)
                            )"
                            :key="index"
                            v-model="permission.checked"
                            :label="permission.value"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                          <v-checkbox
                            :color="$vuetify.theme.currentTheme.primary"
                            @click="checkFormChanges"
                            v-for="(permission, index) in additionalPermissions.slice(
                              Math.ceil(additionalPermissions.length / 2)
                            )"
                            :key="index + Math.ceil(additionalPermissions.length / 2)"
                            v-model="permission.checked"
                            :label="permission.value"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel class="mb-3 border border-gray-300">
                    <v-expansion-panel-header class="py-0">
                      <h3 class="font-medium text-lg text-black dark-text-color">Permissions</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="flex justify-end mb-2">
                        <v-btn
                          :color="$vuetify.theme.currentTheme.primary"
                          class="white--text"
                          @click="toggleAllPermissions"
                        >
                          {{ allPermissionsText }}
                        </v-btn>
                      </div>
                      <div
                        class="mb-2 text-red-600"
                        :class="{
                          'opacity-0': !isFormSubmitted || areAnyPermissionsSelected
                        }"
                      >
                        Please select at least one permission.
                      </div>
                      <v-data-table
                        :headers="permissionHeaders"
                        :items="filteredPermissions"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:item="{ item }">
                          <tr v-if="item.isHeader" class="bg-gray-100">
                            <td colspan="6" class="px-4 font-bold text-gray-700 py-2 border-b">{{ item.name }}</td>
                          </tr>
                          <tr v-else>
                            <td class="px-4">{{ item.name }}</td>
                            <td class="px-4">
                              <v-checkbox
                                v-model="item.read"
                                :color="$vuetify.theme.currentTheme.primary"
                              ></v-checkbox>
                            </td>
                            <td class="px-4">
                              <v-checkbox
                                :color="$vuetify.theme.currentTheme.primary"
                                v-model="item.write"
                                :disabled="checkIsReadChecked(item)"
                              ></v-checkbox>
                            </td>
                            <td class="px-4">
                              <v-checkbox
                                :color="$vuetify.theme.currentTheme.primary"
                                v-model="item.edit"
                                :disabled="checkIsReadChecked(item)"
                              ></v-checkbox>
                            </td>
                            <td class="px-4">
                              <v-checkbox
                                :color="$vuetify.theme.currentTheme.primary"
                                v-model="item.delete"
                                :disabled="checkIsReadChecked(item)"
                              ></v-checkbox>
                            </td>
                            <td class="px-4">
                              <v-chip
                                @click="toggleSelectAllPermissions(item)"
                                class="w-full text-center"
                              >
                                {{ isAllPermissionsSelected(item) ? 'Unselect All' : 'Select All' }}
                              </v-chip>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel class="mb-3 border border-gray-300">
                    <v-expansion-panel-header class="py-0">
                      <h3 class="font-medium text-lg text-black dark-text-color">
                        Module Permissions
                      </h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-data-table
                        :headers="modulePermissionHeaders"
                        :items="modulePermissionsList"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:item="{ item }">
                          <tr>
                            <td class="px-4 font-semibold text-gray-800">{{ item.name }}</td>
                            <td class="px-4">
                              <v-checkbox
                                v-model="item.read"
                                :color="$vuetify.theme.currentTheme.primary"
                                @change="checkFormChanges"
                              ></v-checkbox>
                            </td>
                            <td class="px-4">
                              <v-checkbox
                                v-model="item.add"
                                :color="$vuetify.theme.currentTheme.primary"
                                @change="checkFormChanges"
                              ></v-checkbox>
                            </td>
                            <td class="px-4">
                              <v-checkbox
                                v-model="item.edit"
                                :color="$vuetify.theme.currentTheme.primary"
                                @change="checkFormChanges"
                              ></v-checkbox>
                            </td>
                            <td class="px-4">
                              <v-checkbox
                                v-model="item.delete"
                                :color="$vuetify.theme.currentTheme.primary"
                                @change="checkFormChanges"
                              ></v-checkbox>
                            </td>
                            <td class="px-4">
                              <v-chip
                                @click="toggleSelectAllModulePermissions(item)"
                                class="w-full text-center cursor-pointer"
                              >
                                {{
                                  isAllModulePermissionsSelected(item)
                                    ? 'Unselect All'
                                    : 'Select All'
                                }}
                              </v-chip>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </div>
          </template>
        </ActitiveTabcomponent>
        <div class="border-t px-3 py-3 bg-white">
          <div class="flex justify-end gap-x-4">
            <v-btn outlined @click="closeForm" class="normal-case">Cancel</v-btn>
            <v-btn
              v-if="!isEditingRole"
              :color="$vuetify.theme.currentTheme.primary"
              class="normal-case white--text"
              @click="saveNewRole"
            >
              <v-icon left>mdi-content-save</v-icon>
              Save</v-btn
            >
            <v-btn
              v-if="isEditingRole"
              :color="$vuetify.theme.currentTheme.primary"
              class="normal-case mr-5 white--text"
              @click="updateRole"
              :disabled="isUpdateButtonDisabled"
              >Update</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog for AWS IAM statement json builder and copyable keys -->
    <v-dialog v-model="showIamJsonDialog" max-width="85%" max-height="100vh" persistent>
      <v-card class="d-flex flex-column p-4" style="height: 96vh">
        <v-btn icon @click="showIamJsonDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <!-- <v-card-title class="headline bg-gray-100 flex justify-between items-center px-6 py-4 rounded">
          <span class="font-bold text-gray-800">AWS IAM Policy Statement Builder & JSON Editor</span>
        </v-card-title> -->

        <v-card-text class="flex-grow-1 overflow-y-auto pa-4 mt-2">
          <v-row class="h-full">
            <!-- Left Side: Granular Permission Directory (Filtered by Module Dropdown) -->
            <v-col cols="12" md="6" class="border-r pr-4">
              <div class="mb-4">
                <h4 class="font-semibold text-lg text-gray-800 mb-2">
                  IAM Permission Key Directory
                </h4>
                <p class="text-xs text-gray-500 mb-3">
                  Select a module from the dropdown below, then click Allow / Deny to configure
                  action keys.
                </p>

                <!-- Module Select Dropdown with OptGroups or Headers -->
                <v-select
                  v-model="selectedIamModuleFilter"
                  :items="iamModuleOptions"
                  item-text="label"
                  item-value="key"
                  label="Select Module"
                  outlined
                  dense
                  class="mb-3"
                >
                  <template v-slot:item="{ item }">
                    <div v-if="item.isHeader" class="font-bold text-gray-700 py-1 border-b w-full pointer-events-none" style="font-size: 13px;">
                      {{ item.label }}
                    </div>
                    <div v-else :class="item.parentKey ? 'pl-4 text-gray-600' : 'font-semibold'" style="font-size: 13px;">
                      {{ item.label }}
                    </div>
                  </template>
                </v-select>

                <div class="border rounded p-3 bg-gray-50 max-h-[70vh] overflow-y-auto">
                  <v-list dense class="bg-transparent">
                    <template v-for="(opt, idx) in filteredIamPermissionOptions">
                      <v-list-item :key="idx" class="border-b py-2 px-1">
                        <v-list-item-content>
                          <v-list-item-title class="font-medium text-sm text-gray-900 mb-1">
                            {{ opt.label }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="font-mono text-xs text-blue-600">
                            {{ opt.key }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action class="flex-row items-center space-x-1">
                          <!-- Allow Action Button -->
                          <v-btn
                            v-if="!isActionConfigured(opt.key, 'allow')"
                            small
                            outlined
                            color="success"
                            class="normal-case font-semibold"
                            @click="toggleActionKey(opt.key, 'allow', true)"
                          >
                            Allow
                          </v-btn>
                          <v-btn
                            v-else
                            small
                            depressed
                            color="success"
                            class="normal-case font-semibold white--text"
                            @click="toggleActionKey(opt.key, 'allow', false)"
                          >
                            Allowed <v-icon right x-small>mdi-close</v-icon>
                          </v-btn>

                          <!-- Deny Action Button -->
                          <v-btn
                            v-if="!isActionConfigured(opt.key, 'deny')"
                            small
                            outlined
                            color="error"
                            class="normal-case font-semibold ml-2"
                            @click="toggleActionKey(opt.key, 'deny', true)"
                          >
                            Deny
                          </v-btn>
                          <v-btn
                            v-else
                            small
                            depressed
                            color="error"
                            class="normal-case font-semibold white--text ml-2"
                            @click="toggleActionKey(opt.key, 'deny', false)"
                          >
                            Denied <v-icon right x-small>mdi-close</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                    <v-list-item v-if="filteredIamPermissionOptions.length === 0">
                      <v-list-item-content class="text-center text-gray-400 italic">
                        Select a module to view keys
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </div>
            </v-col>

            <!-- Right Side: JSON Editor & Statements Preview -->
            <v-col cols="12" md="6" class="pl-4 d-flex flex-column">
              <h4 class="font-semibold text-lg text-gray-800 mb-2">IAM Statements Policy JSON</h4>
              <p class="text-xs text-gray-500 mb-3">
                Live rendered policy statements payload (read-only mode).
              </p>
              <v-textarea
                v-model="rawIamJsonString"
                outlined
                readonly
                rows="24"
                class="font-mono text-sm bg-gray-100 flex-grow-1"
                placeholder="IAM statements JSON will auto-generate here..."
                :error-messages="jsonParseError"
              ></v-textarea>

              <div class="mt-3 flex justify-between">
                <v-btn outlined color="error" @click="resetJsonStatements"> Reset JSON </v-btn>
                <v-btn
                  color="primary"
                  class="white--text"
                  :disabled="!!jsonParseError"
                  @click="applyJsonStatements"
                >
                  Apply JSON to Role
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <AlertPopUp
      :showConfirmationDialog="showDeleteDialog"
      :confirmationTitle="'Confirm Delete'"
      :confirmationMessage="`Do you want to delete selected roles?`"
      :confirmationActionText="'DELETE'"
      :confirmationActionColor="'red'"
      :performAction="deleteSelectedRoles"
      :cancel="handleShowDialogDelete"
      :loading="loading"
    />
    <PrevilageTable
      @edit-role="editRole"
      @configure-iam="openIamConfigDialog"
      @role-deleted="handleRoleDeleted"
      @update:options="handleTableOptionsUpdate"
      ref="previlageTable"
      :roles="roles"
      :loadTable="loadTable"
      :totalRoles="totalRoles"
      v-model="selectedRoles"
    />
  </div>
</template>

<script>
import { hasPermission, isModuleVisible, debounce, checkModulePermission } from '@/utils/common'
import permissionData from '@/utils/permissions'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'
import PrevilageTable from './PrevilageTable.vue'
import {
  selectAtLeastOne,
  roleCreationSuccess,
  roleCreationError,
  roleDeleteSuccess,
  roleDeleteError,
  roleUpdateSuccess,
  roleUpdateError
} from '@/utils/toastMessages'
import { axiosUrl } from '@/utils/workforceApi'
import FloatingActionBar from '@/components/Workforce/CollectionManagement/CaseModules/FloatingActionBar.vue'
import AlertPopUp from '@/components/AlertPopUp.vue'
import { getFlatPermissionOptions, registerDynamicUseCase } from '@/utils/permissions.registry'

export default {
  layout: 'Workforce/default',
  name: 'RolesComponent',
  components: {
    ActitiveTabcomponent,
    PrevilageTable,
    FloatingActionBar,
    AlertPopUp
  },
  data() {
    return {
      userData: this.$store.state.wfmPermissions,
      options: { sortBy: [], sortDesc: [], itemsPerPage: 10, page: 1 },
      totalRoles: 0,
      roles: [],
      showIamJsonDialog: false,
      rawIamJsonString:
        '[\n  {\n    "effect": "allow",\n    "actions": []\n  },\n  {\n    "effect": "deny",\n    "actions": []\n  }\n]',
      jsonParseError: null,
      flatPermissionOptions: getFlatPermissionOptions(),
      selectedIamModuleFilter: 'team_review',
      iamStatementsList: [],
      // useCases: [],
      filterRole: '',
      dynamicIamModules: [],
      panel: 0,
      roleName: '',
      showForm: false,
      loadTable: true,
      roleToDeleteId: null,
      roleToEditId: null,
      isEditingRole: false,
      isFormSubmitted: false,
      originalRoleData: null,
      isUpdateButtonDisabled: true,
      permissionHeaders: [
        { text: 'Permission Name', value: 'name' },
        { text: 'View', value: 'read', sortable: false, width: '12%' },
        { text: 'Create', value: 'write', sortable: false, width: '12%' },
        { text: 'Edit', value: 'edit', sortable: false, width: '12%' },
        { text: 'Delete', value: 'delete', sortable: false, width: '12%' },
        { text: 'Action', value: 'action', sortable: false, width: '15%' }
      ],
      permissions: [],
      additionalPermissions: [],
      selectedRoles: [],
      showDeleteDialog: false,
      loading: false,
      modulePermissionHeaders: [
        { text: 'Module Name', value: 'name' },
        { text: 'Read', value: 'read', sortable: false, width: '12%' },
        { text: 'Add', value: 'add', sortable: false, width: '12%' },
        { text: 'Edit', value: 'edit', sortable: false, width: '12%' },
        { text: 'Delete', value: 'delete', sortable: false, width: '12%' },
        { text: 'Action', value: 'action', sortable: false, width: '15%' }
      ],
      modulePermissionsList: []
    }
  },

  watch: {
    options: {
      handler() {
        this.fetchRoles()
      },
      deep: true,
      immediate: false
    },
    roleName() {
      this.checkFormChanges()
    },
    permissions: {
      handler() {
        this.checkFormChanges()
      },
      deep: true
    },
    modulePermissionsList: {
      handler() {
        this.checkFormChanges()
      },
      deep: true
    }
  },

  async mounted() {
    await this.populatePermissions()
    await this.populateModulesConfig()
    // Fetch roles on component mount
    await this.fetchRoles()
  },
  methods: {
    isActionConfigured(key, effect) {
      try {
        const parsed = JSON.parse(this.rawIamJsonString)
        const stmt = parsed.find((s) => s.effect.toLowerCase() === effect.toLowerCase())
        return stmt ? stmt.actions.includes(key) : false
      } catch (e) {
        return false
      }
    },
    toggleActionKey(key, effect, add) {
      try {
        let parsed = []
        try {
          parsed = JSON.parse(this.rawIamJsonString)
        } catch (e) {
          parsed = [
            { effect: 'allow', actions: [] },
            { effect: 'deny', actions: [] }
          ]
        }

        // Find or create statement for effect
        let stmt = parsed.find((s) => s.effect.toLowerCase() === effect.toLowerCase())
        if (!stmt) {
          stmt = { effect, actions: [] }
          parsed.push(stmt)
        }

        if (add) {
          if (!stmt.actions.includes(key)) {
            stmt.actions.push(key)
          }
          // Remove from opposite statement to prevent conflict
          const oppositeEffect = effect === 'allow' ? 'deny' : 'allow'
          const oppStmt = parsed.find((s) => s.effect.toLowerCase() === oppositeEffect)
          if (oppStmt) {
            oppStmt.actions = oppStmt.actions.filter((a) => a !== key)
          }
        } else {
          stmt.actions = stmt.actions.filter((a) => a !== key)
        }

        this.rawIamJsonString = JSON.stringify(parsed, null, 2)
        this.jsonParseError = null
      } catch (err) {
        this.$toast.error(`Error toggling key: ${err.message}`)
      }
    },
    copyToClipboard(text) {
      const formattedText = `"${text}",`
      if (!navigator.clipboard) {
        // Fallback
        const textArea = document.createElement('textarea')
        textArea.value = formattedText
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        try {
          document.execCommand('copy')
          this.$toast.success(`Copied: ${formattedText}`)
        } catch (err) {
          this.$toast.error('Failed to copy')
        }
        document.body.removeChild(textArea)
        return
      }
      navigator.clipboard
        .writeText(formattedText)
        .then(() => {
          this.$toast.success(`Copied formatted key: ${formattedText}`)
        })
        .catch(() => {
          this.$toast.error('Failed to copy key')
        })
    },
    validateJsonInput() {
      if (!this.rawIamJsonString.trim()) {
        this.jsonParseError = 'JSON cannot be empty'
        return false
      }
      try {
        const parsed = JSON.parse(this.rawIamJsonString)
        if (!Array.isArray(parsed)) {
          this.jsonParseError = 'Statements must be a JSON array'
          return false
        }
        for (const stmt of parsed) {
          if (!stmt.effect || !['allow', 'deny'].includes(stmt.effect.toLowerCase())) {
            this.jsonParseError = 'Each statement must have effect: "allow" or "deny"'
            return false
          }
          if (!stmt.actions || !Array.isArray(stmt.actions)) {
            this.jsonParseError = 'Each statement must have an actions string array'
            return false
          }
        }
        this.jsonParseError = null
        return true
      } catch (err) {
        this.jsonParseError = `Invalid JSON: ${err.message}`
        return false
      }
    },
    resetJsonStatements() {
      this.rawIamJsonString =
        '[\n  {\n    "effect": "allow",\n    "actions": []\n  },\n  {\n    "effect": "deny",\n    "actions": []\n  }\n]'
      this.jsonParseError = null
    },
    applyJsonStatements() {
      if (!this.validateJsonInput()) {
        this.$toast.error('Please resolve the JSON validation errors first')
        return
      }
      try {
        const parsed = JSON.parse(this.rawIamJsonString)
        this.iamStatementsList = parsed
        this.showIamJsonDialog = false
        this.$toast.success('Successfully applied JSON policy statements!')

        // If showForm is closed, user clicked from the table row: update automatically
        if (!this.showForm) {
          this.updateRole()
        } else {
          this.checkFormChanges()
        }
      } catch (err) {
        this.$toast.error(`Error applying statements: ${err.message}`)
      }
    },
    resetForm() {
      this.roleName = ''
      this.rawIamJsonString =
        '[\n  {\n    "effect": "allow",\n    "actions": []\n  },\n  {\n    "effect": "deny",\n    "actions": []\n  }\n]'
      this.jsonParseError = null
      this.iamStatementsList = []
      this.permissions.forEach((permission) => {
        permission.read = false
        permission.write = false
        permission.edit = false
        permission.delete = false
      })
      this.additionalPermissions.forEach((permission) => {
        permission.checked = false
      })
      this.modulePermissionsList.forEach((permission) => {
        permission.read = false
        permission.add = false
        permission.edit = false
        permission.delete = false
      })
    },

    isRoleModuleShouldVisible(module) {
      return checkModulePermission(module)
    },

    openForm() {
      this.isFormSubmitted = false
      this.isEditingRole = false
      this.resetForm()
      this.showForm = true
    },
    async populateModulesConfig() {
      try {
        const response = await this.$axios.get(axiosUrl.role.populateModulesConfig)
        const moduleConfig = response.data.modules

        this.modulePermissionsList = Object.keys(moduleConfig).map((moduleName) => {
          return {
            key: moduleName,
            name: moduleConfig[moduleName].label,
            read: false,
            add: false,
            edit: false,
            delete: false
          }
        })
      } catch (error) {
        console.error('Error fetching module config:', error)
      }
    },
    async populatePermissions() {
      try {
        const permsResponse = await this.$axios.get(axiosUrl.role.populatePermissions)

        const availableModules = permsResponse.data.modules
        this.additionalPermissions = permsResponse.data.privileges

        const initialPermissions = Object.keys(availableModules).map((moduleName) => {
          return {
            key: moduleName,
            name: availableModules[moduleName],
            read: false,
            write: false,
            edit: false,
            delete: false,
            visibility: this.isRoleModuleShouldVisible(moduleName)
          }
        })

        // Fetch dynamic allowed use cases & extend usecases to register dynamic subcases
        try {
          const [allowedRes, extendRes] = await Promise.all([
            this.$axios.get('/orgSetup/allowed-use-cases'),
            this.$axios.get('/orgSetup/extend-usecase')
          ])

          const allowedCases = allowedRes.data?.data || []
          const extendCases = extendRes.data?.data || []

          const dynamicModulesList = []
          allowedCases.forEach((allowed) => {
            const subCases = extendCases.filter((sc) => sc.useCase === allowed.useCase)
            
            // Register dynamic usecase submodule tree in the registry
            registerDynamicUseCase(allowed.useCase, allowed.navName, subCases)

            const useCaseLabel = allowed.navName || allowed.useCase.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
            
            // Push Use Case Header
            dynamicModulesList.push({
              key: `header_${allowed.useCase}`,
              label: useCaseLabel,
              isHeader: true
            })

            // Push Sub Case Child
            subCases.forEach((subCase) => {
              const displayName = subCase.name.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
              dynamicModulesList.push({
                key: `${allowed.useCase}.${subCase._id}`,
                label: `↳ ${displayName}`,
                parentKey: allowed.useCase
              })
            })

            // Push a non-selectable header row for the parent Use Case category
            initialPermissions.push({
              key: `header_${allowed.useCase}`,
              name: useCaseLabel,
              isHeader: true,
              read: false,
              write: false,
              edit: false,
              delete: false,
              visibility: true
            })

            // Push permission rows to the Roles layout permissions list (module level check)
            subCases.forEach((subCase) => {
              const displayName = subCase.name.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
              
              initialPermissions.push({
                key: `${allowed.useCase}.${subCase._id}`,
                name: `    ↳ ${displayName}`,
                read: false,
                write: false,
                edit: false,
                delete: false,
                visibility: true
              })
            })
          })

          this.dynamicIamModules = dynamicModulesList

          // Rebuild flat permission list for statement builder with dynamic keys included
          this.flatPermissionOptions = getFlatPermissionOptions()

        } catch (dynamicError) {
          console.error('Error populating dynamic permissions:', dynamicError)
        }

        this.permissions = initialPermissions
      } catch (error) {
        console.error('Error fetching available modules:', error)
      }
    },
    handleInput: debounce(async function () {
      this.options.page = 1
      await this.fetchRoles()
    }, 500),
    async fetchRoles() {
      try {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        const params = {
          page: page,
          limit: itemsPerPage > -1 ? itemsPerPage : this.totalTasks
        }

        if (sortBy.length > 0) {
          params.sortBy = sortBy[0]
        }
        if (sortDesc.length > 0) {
          params.sortOrder = sortDesc[0] ? 'desc' : 'asc'
        }
        if (this.filterRole) [(params.search = this.filterRole)]

        this.loadTable = true
        const response = await this.$axios.get(axiosUrl.role.getRoles, {
          params: params
        })

        if (response.data.success) {
          this.roles = response.data.roles
          this.loadTable = false

          this.totalRoles = response.data.pagination?.totalCount || this.roles.length
        } else {
          console.error('Error fetching roles:', response.data.message)
        }
      } catch (error) {
        console.error('Error fetching roles:', error)
        this.loadTable = false
      }
    },
    handleTableOptionsUpdate(newOptions) {
      // Update the options and trigger fetchRoles
      this.options = { ...this.options, ...newOptions }
    },

    async saveNewRole() {
      try {
        this.isFormSubmitted = true

        const isValid = !!this.roleName

        if (!isValid) {
          return
        }

        const isAnyPermissionSelected = this.permissions.some((permission) => {
          return permission.read || permission.write || permission.edit || permission.delete
        })

        if (!isAnyPermissionSelected) {
          this.$toast.error(selectAtLeastOne)
          return
        }

        const selectedPrivilege = []

        this.additionalPermissions.forEach((permission) => {
          if (permission.checked) {
            selectedPrivilege.push(`${permission.key}`)
          }
        })
        const selectedPermissions = []

        this.permissions.forEach((permission) => {
          if (permission.isHeader) return
          if (permission.read) {
            selectedPermissions.push(`${permission.key}:read`)
          }
          if (permission.write) {
            selectedPermissions.push(`${permission.key}:write`)
          }
          if (permission.edit) {
            selectedPermissions.push(`${permission.key}:edit`)
          }
          if (permission.delete) {
            selectedPermissions.push(`${permission.key}:delete`)
          }
        })

        const modulePermissionsObj = {}
        this.modulePermissionsList.forEach((m) => {
          modulePermissionsObj[m.key] = {
            read: !!m.read,
            add: !!m.add,
            edit: !!m.edit,
            delete: !!m.delete
          }
        })

        const requestBody = {
          role: this.roleName,
          permissions: selectedPermissions,
          extraPrivileges: selectedPrivilege,
          modulePermissions: modulePermissionsObj,
          statements: this.iamStatementsList.filter((s) => s.actions && s.actions.length > 0)
        }

        const response = await this.$axios.post(axiosUrl.role.postRoles, requestBody)

        if (response.data.success) {
          // Add the new role to the list
          this.roles.push(response.data.role)
          this.totalRoles += 1
          this.$toast.success(roleCreationSuccess)
          this.resetForm()
          this.showForm = false
        } else {
          this.$toast.error(roleCreationError)
          console.error(roleCreationError, response.data.message)
        }
      } catch (error) {
        this.$toast.error(roleCreationError)
        console.error(roleCreationError, error)
      }
    },

    async editRole(roleData) {
      this.originalRoleData = { ...roleData }

      this.roleName = roleData.role

      this.permissions.forEach((permission) => {
        permission.read = roleData?.permissions?.includes(`${permission.key}:read`)
        permission.write = roleData?.permissions?.includes(`${permission.key}:write`)
        permission.edit = roleData?.permissions?.includes(`${permission.key}:edit`)
        permission.delete = roleData?.permissions?.includes(`${permission.key}:delete`)
      })
      this.additionalPermissions.forEach((permission) => {
        permission.checked = roleData?.extraPrivileges?.includes(permission.key)
      })
      this.modulePermissionsList.forEach((m) => {
        const savedPerms = roleData?.modulePermissions?.[m.key] || {}
        m.read = !!savedPerms.read
        m.add = !!savedPerms.add
        m.edit = !!savedPerms.edit
        m.delete = !!savedPerms.delete
      })

      this.isUpdateButtonDisabled = true

      if (
        roleData?.statements &&
        Array.isArray(roleData.statements) &&
        roleData.statements.length > 0
      ) {
        this.rawIamJsonString = JSON.stringify(roleData.statements, null, 2)
      } else {
        this.rawIamJsonString = '[\n  {\n    "effect": "allow",\n    "actions": []\n  }\n]'
      }

      this.isEditingRole = true
      this.roleToEditId = roleData._id

      this.showForm = true
    },

    checkFormChanges() {
      // Compare the form data with the original roleData
      if (this.originalRoleData) {
        const isRoleNameChanged = this.roleName.trim() !== this.originalRoleData.role

        const isPermissionsChanged = this.permissions.some((permission) => {
          return (
            permission.read !==
              this.originalRoleData?.permissions?.includes(`${permission.key}:read`) ||
            permission.write !==
              this.originalRoleData?.permissions?.includes(`${permission.key}:write`) ||
            permission.edit !==
              this.originalRoleData?.permissions?.includes(`${permission.key}:edit`) ||
            permission.delete !==
              this.originalRoleData?.permissions?.includes(`${permission.key}:delete`)
          )
        })

        const originalKeys = this.originalRoleData.extraPrivileges.sort() // Sort for consistent comparison
        const currentKeys = this.additionalPermissions
          .filter((permission) => permission.checked)
          .map((permission) => permission.key)
          .sort()

        const isAdditionalPermissionsChanged =
          JSON.stringify(originalKeys) !== JSON.stringify(currentKeys)

        const isModulePermissionsChanged = this.modulePermissionsList.some((m) => {
          const savedPerms = this.originalRoleData?.modulePermissions?.[m.key] || {}
          return (
            m.read !== !!savedPerms.read ||
            m.add !== !!savedPerms.add ||
            m.edit !== !!savedPerms.edit ||
            m.delete !== !!savedPerms.delete
          )
        })

        const isStatementsChanged =
          JSON.stringify(this.iamStatementsList) !==
          JSON.stringify(this.originalRoleData?.statements || [])

        this.isUpdateButtonDisabled = !(
          isRoleNameChanged ||
          isPermissionsChanged ||
          isAdditionalPermissionsChanged ||
          isModulePermissionsChanged ||
          isStatementsChanged
        )
      }
    },
    async updateRole() {
      try {
        this.isFormSubmitted = true

        const isValid = !!this.roleName

        if (!isValid) {
          return
        }

        const isAnyPermissionSelected = this.permissions.some((permission) => {
          return permission.read || permission.write || permission.edit || permission.delete
        })

        if (!isAnyPermissionSelected) {
          this.$toast.error(selectAtLeastOne)
          return
        }
        const selectedPrivilege = []

        this.additionalPermissions.forEach((permission) => {
          if (permission.checked) {
            selectedPrivilege.push(`${permission.key}`)
          }
        })

        const selectedPermissions = []

        this.permissions.forEach((permission) => {
          if (permission.isHeader) return
          if (permission.read) {
            selectedPermissions.push(`${permission.key}:read`)
          }
          if (permission.write) {
            selectedPermissions.push(`${permission.key}:write`)
          }
          if (permission.edit) {
            selectedPermissions.push(`${permission.key}:edit`)
          }
          if (permission.delete) {
            selectedPermissions.push(`${permission.key}:delete`)
          }
        })

        const modulePermissionsObj = {}
        this.modulePermissionsList.forEach((m) => {
          modulePermissionsObj[m.key] = {
            read: !!m.read,
            add: !!m.add,
            edit: !!m.edit,
            delete: !!m.delete
          }
        })

        const requestBody = {
          role: this.roleName,
          permissions: selectedPermissions,
          extraPrivileges: selectedPrivilege,
          modulePermissions: modulePermissionsObj,
          statements: this.iamStatementsList.filter((s) => s.actions && s.actions.length > 0)
        }

        const response = await this.$axios.put(
          `${axiosUrl.role.putRoles}/${this.roleToEditId}`,
          requestBody
        )

        if (response.data.success) {
          const updatedRoleIndex = this.roles.findIndex((role) => role._id === this.roleToEditId)
          if (updatedRoleIndex !== -1) {
            // Replace the updated role in the list
            this.roles.splice(updatedRoleIndex, 1, response.data.role)
          }
          this.$toast.success(roleUpdateSuccess)
          this.resetForm()
          this.isEditingRole = false

          this.showForm = false
        } else {
          this.$toast.error(roleUpdateError)
          console.error(roleUpdateError, response.data.message)
        }
      } catch (error) {
        this.$toast.error(roleUpdateError)
        console.error(roleUpdateError, error)
      }
    },

    closeForm() {
      this.isFormSubmitted = false
      this.showForm = false
      this.resetForm()
    },
    checkIsReadChecked(item) {
      if (!item.read) {
        item.write = false
        item.edit = false
        item.delete = false
      }
      return !item.read
    },
    toggleAllPermissions() {
      if (this.areAllPermissionsSelected()) {
        this.permissions.forEach((permission) => {
          if (permission.isHeader) return
          permission.read = false
          permission.write = false
          permission.edit = false
          permission.delete = false
        })
      } else {
        this.permissions.forEach((permission) => {
          if (permission.isHeader) return
          permission.read = true
          permission.write = true
          permission.edit = true
          permission.delete = true
        })
      }
    },
    toggleAllPrivilegePermissions() {
      if (this.allPrivilegePermissionsText == 'Deselect All') {
        this.additionalPermissions = this.additionalPermissions.map((permission) => {
          return {
            ...permission,
            checked: false
          }
        })
      } else {
        this.additionalPermissions = this.additionalPermissions.map((permission) => {
          return {
            ...permission,
            checked: true
          }
        })
      }
    },
    areAllPermissionsSelected() {
      return this.permissions.every((permission) => {
        if (permission.isHeader) return true
        return permission.read && permission.write && permission.edit && permission.delete
      })
    },
    toggleSelectAllPermissions(item) {
      const isSelected = this.isAllPermissionsSelected(item)

      if (isSelected) {
        this.deselectAllPermissions(item)
      } else {
        this.selectAllPermissions(item)
      }
    },

    selectAllPermissions(item) {
      item.read = true
      item.write = true
      item.edit = true
      item.delete = true
    },

    deselectAllPermissions(item) {
      item.read = false
      item.write = false
      item.edit = false
      item.delete = false
    },
    isAllPermissionsSelected(item) {
      return item.read && item.write && item.edit && item.delete
    },
    toggleSelectAllModulePermissions(item) {
      const isSelected = this.isAllModulePermissionsSelected(item)
      item.read = !isSelected
      item.add = !isSelected
      item.edit = !isSelected
      item.delete = !isSelected
      this.checkFormChanges()
    },
    isAllModulePermissionsSelected(item) {
      return item.read && item.add && item.edit && item.delete
    },
    // async getConfig() {
    //   try {
    //     const response = await this.$axios.get('/org/config')

    //     const data = response.data?.config
    //     this.useCases = data.enabledUseCases

    //     return data || {}
    //   } catch (error) {
    //     console.error('Error fetching config:', error)
    //   }
    // },

    // Method to be called from parent component (OrganizationHierarchy.vue)
    addRole() {
      this.openForm()
    },
    handleRoleDeleted(roleId) {
      // Remove the deleted role from the list
      const roleIndex = this.roles.findIndex((role) => role._id === roleId)
      if (roleIndex !== -1) {
        this.roles.splice(roleIndex, 1)
        this.totalRoles -= 1
      }
      // Refresh the roles list
      this.fetchRoles()
    },
    handleShowDialogDelete() {
      this.showDeleteDialog = !this.showDeleteDialog
      if (this.showDeleteDialog === false) {
        this.fetchRoles()
      }
    },
    async deleteSelectedRoles() {
      this.loading = true

      const promises = []

      // Make API calls and store promises in the array
      this.selectedRoles?.forEach(async (item) => {
        promises.push(this.deleteSingleRole(item._id))
      })

      // Wait for all API calls to complete
      try {
        const results = await Promise.all(promises)

        if (!results.includes(undefined)) {
          this.$toast.success('Roles deleted successfully.')
        }
        this.loading = false
        this.selectedRoles = []
        this.handleShowDialogDelete(false)
      } catch (error) {
        this.$toast.error('An error occurred while deleting the roles.')
        console.error(error)
      }
    },
    async openIamConfigDialog(roleData) {
      this.originalRoleData = { ...roleData }
      this.roleToEditId = roleData._id
      this.roleName = roleData.role
      this.isEditingRole = true

      // Load existing permissions & privileges to keep them in sync
      this.permissions.forEach((permission) => {
        permission.read = roleData?.permissions?.includes(`${permission.key}:read`)
        permission.write = roleData?.permissions?.includes(`${permission.key}:write`)
        permission.edit = roleData?.permissions?.includes(`${permission.key}:edit`)
        permission.delete = roleData?.permissions?.includes(`${permission.key}:delete`)
      })
      this.additionalPermissions.forEach((permission) => {
        permission.checked = roleData?.extraPrivileges?.includes(permission.key)
      })
      this.modulePermissionsList.forEach((m) => {
        const savedPerms = roleData?.modulePermissions?.[m.key] || {}
        m.read = !!savedPerms.read
        m.add = !!savedPerms.add
        m.edit = !!savedPerms.edit
        m.delete = !!savedPerms.delete
      })

      if (
        roleData?.statements &&
        Array.isArray(roleData.statements) &&
        roleData.statements.length > 0
      ) {
        this.rawIamJsonString = JSON.stringify(roleData.statements, null, 2)
        this.iamStatementsList = [...roleData.statements]
      } else {
        this.rawIamJsonString =
          '[\n  {\n    "effect": "allow",\n    "actions": []\n  },\n  {\n    "effect": "deny",\n    "actions": []\n  }\n]'
        this.iamStatementsList = []
      }
      this.jsonParseError = null
      this.showIamJsonDialog = true
    },
    async deleteSingleRole(roleId) {
      try {
        let response = await this.$axios.delete(`${axiosUrl.role.deleteRoles}/${roleId}`)
        return response.data
      } catch (error) {
        console.error(error)
      }
    }
  },
  computed: {
    mainTabs() {
      const tabs = [
        {
          label: this.isEditingRole ? 'Edit Role' : 'Add Role',
          key: 'lender',
          icon: this.isEditingRole ? 'mdi-pencil' : 'mdi-plus',
          component: 'Roles'
        }
      ]
      return tabs
    },
    allPrivilegePermissionsText() {
      const allChecked = this.additionalPermissions.every((permission) => permission.checked)
      return allChecked ? 'Deselect All' : 'Select All'
    },
    areAnyPermissionsSelected() {
      return this.permissions.some((permission) => {
        return permission.read || permission.write || permission.edit || permission.delete
      })
    },
    allPermissionsText() {
      return this.areAllPermissionsSelected() ? 'Unselect All' : 'Select All'
    },
    canAdd() {
      return hasPermission(this.userData, permissionData.settingWrite)
    },
    roleNameValidationRule() {
      return !this.roleName && this.isFormSubmitted ? ['Required.'] : []
    },
    filteredPermissions() {
      return this.permissions.filter((permission) => permission.visibility)
    },
    iamModuleOptions() {
      const staticOptions = [
        { key: 'team_review', label: 'Team Review' },
        { key: 'organization', label: 'Organization Hierarchy' },
        { key: 'customers', label: 'Customer Management' },
        { key: 'accounting', label: 'Accounting' },
        { key: 'workflows', label: 'Workflow Setup' },
        { key: 'reports', label: 'Reports Dashboard' },
        { key: 'batch_reports', label: 'Batch Reports' },
        { key: 'notifications', label: 'Notification Integration' },
        { key: 'learning', label: 'Learning & Trainings' },
        { key: 'dynamic_forms', label: 'Dynamic Forms & Responses' },
        { key: 'alerts', label: 'Approvals' }
      ]
      return [...staticOptions, ...this.dynamicIamModules]
    },
    filteredIamPermissionOptions() {
      if (!this.selectedIamModuleFilter || this.selectedIamModuleFilter.startsWith('header_')) return []
      return this.flatPermissionOptions.filter((opt) =>
        opt.key.startsWith(this.selectedIamModuleFilter)
      )
    }
  }
}
</script>

<style scoped>
.permission-fade-enter-active,
.permission-fade-leave-active {
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.permission-fade-enter,
.permission-fade-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

.opacity-0 {
  transition: opacity 0.3s;
  opacity: 0;
  margin-bottom: 0;
}

.appear-delay {
  transition: opacity 0.3s ease-in-out 0.1s;
}
.table-header {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.bord {
  border-top: thin solid rgba(0, 0, 0, 0.12);
}

.v-input--is-disabled .v-input__control {
  opacity: 0.5;
}
.form-content {
  padding: 12px;
  max-height: 70vh;
  overflow-y: auto;
}
</style>
